/**
 * VI-548 exit-intent timing configuration.
 *
 * Defaults come straight from the ticket AC:
 *   - Landing page: mouse-leave 3s delay, idle 30s
 *   - Interview pages: mouse-leave 10s delay, idle 120s
 *
 * Each value can be overridden at runtime via a Vite env var so we can tune
 * per environment (local / QA / UAT / prod) without code changes. Invalid or
 * missing values fall back to the AC defaults.
 */

const parsePositiveInt = (
  value: string | undefined,
  fallback: number,
): number => {
  if (!value) return fallback;
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export interface ExitIntentTimings {
  mouseLeaveDelayMs: number;
  idleSeconds: number;
}

export const EXIT_INTENT_LANDING_TIMINGS: ExitIntentTimings = {
  mouseLeaveDelayMs: parsePositiveInt(
    import.meta.env.VITE_EXIT_INTENT_LANDING_MOUSE_LEAVE_DELAY_MS,
    3000,
  ),
  idleSeconds: parsePositiveInt(
    import.meta.env.VITE_EXIT_INTENT_LANDING_IDLE_SECONDS,
    30,
  ),
};

export const EXIT_INTENT_INTERVIEW_TIMINGS: ExitIntentTimings = {
  mouseLeaveDelayMs: parsePositiveInt(
    import.meta.env.VITE_EXIT_INTENT_INTERVIEW_MOUSE_LEAVE_DELAY_MS,
    10000,
  ),
  idleSeconds: parsePositiveInt(
    import.meta.env.VITE_EXIT_INTENT_INTERVIEW_IDLE_SECONDS,
    120,
  ),
};
